import keysToConstants from 'js/lib/keysToConstants';

const exported = keysToConstants(['Member', 'GroupManager', 'DerivedGroupManager']);

export const { Member, GroupManager, DerivedGroupManager } = exported;

export default exported;
